// Resolve the auth mode the app should run in.
//
//   - telegram : opened inside the Mini App; initData rides every request
//   - session  : opened in a normal browser, cookie present \u2014 we'll find
//                out for sure on the first /api/me call
//   - demo     : explicit ?demo=1 mode (see lib/demo.ts)
//   - anonymous: outside Telegram, no cookie, not demo \u2014 show login gate
//
// The "session vs anonymous" split can't be answered from JS (the cookie
// is HttpOnly), so the App boot path optimistically calls api.me() and
// flips to anonymous on 401.

import { isDemoMode } from "./demo";
import { tg } from "./telegram";

export type AuthMode = "telegram" | "browser" | "demo";

export function getAuthMode(): AuthMode {
  if (isDemoMode()) return "demo";
  const app = tg();
  if (app && app.initData && app.initData.length >= 30) return "telegram";
  return "browser";
}

/** True when the app is rendered inside the Telegram Mini App webview. */
export function isInTelegram(): boolean {
  const app = tg();
  return !!(app && app.initData && app.initData.length >= 30);
}
